import { render, staticRenderFns } from "./editBanksOpeningBalance.vue?vue&type=template&id=4ac438cc"
import script from "./editBanksOpeningBalance.vue?vue&type=script&lang=js"
export * from "./editBanksOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./editBanksOpeningBalance.vue?vue&type=style&index=0&id=4ac438cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports